import React from "react";

const Icon_3 = () => {
  return (
    <>
     <svg width="102" height="124" viewBox="0 0 102 124" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99999 0H71.7954C73.9188 0 75.9871 0.675924 77.7007 1.92988L97.9053 16.7147C100.479 18.598 102 21.5958 102 24.7848V114C102 119.523 97.5229 124 92 124H10C4.47715 124 0 119.523 0 114V10C0 4.47715 4.47714 0 9.99999 0Z" fill="url(#paint0_linear_3321_20748)"/>
<rect width="49" height="7" rx="3.5" transform="matrix(-1 0 0 1 59 17)" fill="url(#paint1_linear_3321_20748)"/>
<rect x="10" y="34" width="81" height="6" rx="3" fill="url(#paint2_linear_3321_20748)"/>
<rect x="10" y="50" width="41" height="6" rx="3" fill="url(#paint3_linear_3321_20748)"/>
<rect x="10" y="66" width="82" height="6" rx="3" fill="url(#paint4_linear_3321_20748)"/>
<rect x="10" y="82" width="82" height="6" rx="3" fill="url(#paint5_linear_3321_20748)"/>
<rect x="10" y="98" width="82" height="6" rx="3" fill="url(#paint6_linear_3321_20748)"/>
<defs>
<linearGradient id="paint0_linear_3321_20748" x1="51" y1="0" x2="51" y2="124" gradientUnits="userSpaceOnUse">
<stop stopColor="#1A2732"/>
<stop offset="1" stopColor="#040D18"/>
</linearGradient>
<linearGradient id="paint1_linear_3321_20748" x1="0" y1="3.5" x2="49" y2="3.5" gradientUnits="userSpaceOnUse">
<stop stopColor="#1A2732"/>
<stop offset="1" stopColor="#263645"/>
</linearGradient>
<linearGradient id="paint2_linear_3321_20748" x1="10" y1="37" x2="91" y2="37" gradientUnits="userSpaceOnUse">
<stop stopColor="#1D2C38"/>
<stop offset="1" stopColor="#15222D"/>
</linearGradient>
<linearGradient id="paint3_linear_3321_20748" x1="10" y1="53" x2="51" y2="53" gradientUnits="userSpaceOnUse">
<stop stopColor="#1A2732"/>
<stop offset="0.49" stopColor="#2D3E53"/>
</linearGradient>
<linearGradient id="paint4_linear_3321_20748" x1="10" y1="69" x2="92" y2="69" gradientUnits="userSpaceOnUse">
<stop offset="0.2" stopColor="#1A2732"/>
<stop offset="1" stopColor="#202D3D"/>
</linearGradient>
<linearGradient id="paint5_linear_3321_20748" x1="10" y1="85" x2="92" y2="85" gradientUnits="userSpaceOnUse">
<stop offset="0.28" stopColor="#1A2732"/>
<stop offset="1" stopColor="#202D3D"/>
</linearGradient>
<linearGradient id="paint6_linear_3321_20748" x1="10" y1="101" x2="92" y2="101" gradientUnits="userSpaceOnUse">
<stop offset="0.18" stopColor="#1A2732"/>
<stop offset="1" stopColor="#202D3D"/>
</linearGradient>
</defs>
</svg>
    </>
  );
};

export default Icon_3;
